export const TimeOptionsEnum = {
  minute: 'мин.',
  hour: 'ч.',
  day: 'д.',
};

export type TTimeOptions = 'мин.' | 'ч.' | 'д.';

export const TimeOptions = [TimeOptionsEnum.minute, TimeOptionsEnum.hour, TimeOptionsEnum.day];

export const getFirstTimeOptions = (n: number) => TimeOptions.slice(0, n);